import React from 'react';
import { useTranslation } from 'react-i18next';

interface StarRatingProps {
  value: number | null;
  onChange?: (newValue: number) => void;
  readOnly?: boolean;
  starSize?: number;
  showLabel?: boolean; // new prop to toggle label display
}

const StarRating: React.FC<StarRatingProps> = ({
  value,
  onChange,
  readOnly = false,
  starSize = 24,
  showLabel = true
}) => {
  const { t } = useTranslation<'common'>();
  const [hoverValue, setHoverValue] = React.useState<number | null>(null);
  const [selectedValue, setSelectedValue] = React.useState<number | null>(value);
  const [isClicked, setIsClicked] = React.useState(false);

  React.useEffect(() => {
    setSelectedValue(value);
  }, [value]);

  const ratingLabels: { [key: number]: string } = {
    1: t('rating.terrible'),
    2: t('rating.poor'),
    3: t('rating.average'),
    4: t('rating.good'),
    5: t('rating.excellent'),
  };

  const handleClick = (newValue: number) => {
    if (readOnly) return;
    setSelectedValue(newValue);
    setIsClicked(true);
    if (onChange) onChange(newValue);
  };

  const handleMouseEnter = (newValue: number) => {
    if (readOnly) return;
    setHoverValue(newValue);
  };

  const handleMouseLeave = () => {
    if (readOnly) return;
    setHoverValue(null);
  };

  const currentValue = hoverValue ?? selectedValue;

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <div style={{ display: 'flex' }}>
        {[1, 2, 3, 4, 5].map((star) => {
          const isFilled = currentValue ? star <= currentValue : false;

          return (
            <div
              key={star}
              onClick={() => handleClick(star)}
              onMouseEnter={() => handleMouseEnter(star)}
              onMouseLeave={handleMouseLeave}
              style={{
                width: `${starSize}px`,
                height: `${starSize}px`,
                borderRadius: '50%',
                border: '2px solid #890608',
                marginRight: '6px',
                cursor: readOnly ? 'default' : 'pointer',
                backgroundColor: isFilled ? '#890608' : 'transparent',
                transition: 'background-color 0.2s ease',
                position: 'relative',
              }}
            />
          );
        })}
      </div>

      {showLabel && (currentValue || isClicked) && (
        <span
          style={{
            marginLeft: '6px',
            fontSize: '16px',
            //color: '#890608',
            //fontWeight: 'bold',
            minWidth: '100px',
          }}
        >
          {ratingLabels[currentValue || selectedValue || 0]}
        </span>
      )}
    </div>
  );
};

export default StarRating;
